import { ADD_PACKAGE_BOXES_FAILURE, ADD_PACKAGE_BOXES_REQUEST, ADD_PACKAGE_BOXES_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const addPackageBoxesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PACKAGE_BOXES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case ADD_PACKAGE_BOXES_REQUEST:
            return Object.assign({}, state);
        case ADD_PACKAGE_BOXES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default addPackageBoxesReducer;
